<template>
<div class="ui form" >

  <div>
    <img src="assets/images/rewaco-logo-white.svg" />
  </div>

  <h2><b>Login</b></h2>
  <div class="fields" style="text-align: left;margin-left: 25%;margin-right: 25%;">
    <div class="field">
      <label>Username</label>
      <input type="text" v-model="username" style="max-width: 300px;">
    </div>
    <div class="field">
      <label>Password</label>
      <input type="password" v-model="password">
    </div>
    </p>
    <br>

  </div>
  <button @click="login()">login</button>
</div>
</template>

<script>
import User from '../enteties/User';

export default {
  name: 'Login',
  props: {},
  data: function() {
    return {
      user: User,
      username: '',
      password: ''
    }
  },
  methods: {
    login: function() {
      if (this.password == "rewaco2.0" && this.username == "") {
        this.user.username = this.username;
        this.user.logedin = true;
        this.$router.push({
          path: 'dashboard'
        })
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
